import styles from "../../styles/AGBModal.module.css";

export default function AGBModal({ close }) {

    return (
        <div className={styles.overlay} onClick={close}>

            <div className={styles.modal} onClick={(e) => e.stopPropagation()}>

                <button className={styles.closeBtn} onClick={close}>
                    ✕
                </button>

                <div className={styles.agbHeader}>
                    <h2>Allgemeine Geschäftsbedingungen</h2>
                
                </div>

                <div className={styles.agbBody}>
                    <h3>Bedingungen</h3>

                    <p>
                        Erarbeitet von der Bundesinnung der Fahrzeugtechnik und dem Fachverband der Fahrzeugindustrie Österreichs.
                        <br />
                        Ausgabe Jänner 2021
                    </p>

                    <ol>
                        <li>
                            <strong>Geltung</strong>
                            <ol>
                                <li>Diese Geschäftsbedingungen gelten zwischen uns Dreamgarage - Ing.Mst Andreas Rudolf Martin GRUBER und natürlichen und juristischen Personen(kurz Kunde) für das gegenständliche Rechtsgeschäft sowie gegenüber unternehmerischen Kunden auch für alle hinkünftigen Geschäfte, selbst wenn im Einzelfall, insbesondere bei künftigen Ergänzungs- oder Folgeaufträgen darauf nicht ausdrücklich Bezug genommen wurde.</li>
                                <li>Es gilt gegenüber unternehmerischen Kunden jeweils die bei Vertragsabschluss aktuelle Fassung unserer AGB, abrufbar auf unserer Homepage www.dreamgarage.at. Diese wird auch den Kunden zugestellt.</li>
                                <li>Wir kontrahieren ausschließlich unter Zugrundelegung unserer AGB.</li>
                                <li>Geschäftsbedingungen des Kunden oder Änderungen bzw. Ergänzungen unserer AGB bedürfen zu ihrer Geltung unserer ausdrücklichen – gegenüber unternehmerischen Kunden schriftlichen – Zustimmung.</li>
                                <li>Geschäftsbedingungen des Kunden werden auch dann nicht anerkannt, wenn wir ihnen nach Eingang bei uns nicht ausdrücklich widersprechen.</li>
                            </ol>
                        </li>

                        <li>
                            <strong>Angebot / Vertragsabschluss</strong>
                            <ol>
                                <li>Unsere Angebote sind unverbindlich.</li>
                                <li>Zusagen, Zusicherungen und Garantien unsererseits oder von diesen AGB abweichende Vereinbarungen im Zusammenhang mit dem Vertragsabschluss werden gegenüber unternehmerischen Kunden erst durch unsere schriftliche Bestätigung verbindlich.</li>
                                <li>In Katalogen, Preislisten, Prospekten, Anzeigen auf Messeständen, Rundschreiben, Werbeaussendungen oder anderen Medien (Informationsmaterial) angeführte Informationen über unsere Produkte und Leistungen, die nicht uns zuzurechnen sind, hat der Kunde – sofern der Kunde diese seiner Entscheidung zur Beauftragung zugrunde legt – uns darzulegen. Diesfalls können wir zu deren Richtigkeit Stellung nehmen. Verletzt der Kunde diese Obliegenheit, sind derartige Angaben unverbindlich, soweit diese nicht ausdrücklich – unternehmerischen Kunden gegenüber schriftlich – zum Vertragsinhalt erklärt wurden.</li>
                                <li>Kostenvoranschläge werden ohne Gewähr erstellt und sind entgeltlich. Verbraucher werden vor Erstellung des Kostenvoranschlages auf die Kostenpflicht hingewiesen. Erfolgt eine Beauftragung mit sämtlichen im Kostenvoranschlag umfassten Leistungen, wird von der gegenständlichen Rechnung das Entgelt für den Kostenvoranschlag in Abzug gebracht.</li>
                            </ol>
                        </li>

                        <li>
                            <strong>Preise</strong>
                            <ol>
                                <li>Sofern nicht ausdrücklich anders angegeben, verstehen sich Preisangaben nicht als Pauschalpreise.</li>
                                <li>Aktuelle Preise, Stundensätze und Gebühren sind in unseren Geschäftsräumlichkeiten sowie auf unserer Website unter www.dreamgarage.at ausgewiesen.</li>
                                <li>
                                    Wird das Fahrzeug nicht innerhalb von 3 Werktagen nach Verständigung über die Fertigstellung abgeholt, ist die Werkstatt berechtigt, Standgebühren zu verrechnen. Diese betragen:
                                    <ul>
                                        <li>€ 8,– pro Kalendertag für zweirädrige Kraftfahrzeuge</li>
                                        <li>€ 20,– pro Kalendertag für vierrädrige Kraftfahrzeuge / Anhänger</li>
                                    </ul>
                                    Die Standgebühren dienen dem Ersatz des Platz- und Verwaltungsaufwandes. Bei längerem Abstellen behalten wir uns vor, das Fahrzeug auf einen externen Abstellplatz zu verbringen. Die dadurch entstehenden Kosten trägt der Kunde.
                                </li>
                                <li>Für vom Kunden angeordnete Leistungen, die im ursprünglichen Auftrag keine Deckung finden, besteht Anspruch auf angemessenes Entgelt.</li>
                                <li>Preisangaben verstehen sich zuzüglich der jeweils geltenden gesetzlichen Umsatzsteuer und ab Lager. Verpackungs-, Transport-, Verladungs- und Versandkosten sowie Zoll und Versicherung gehen zu Lasten des unternehmerischen Kunden. Verbrauchern als Kunden gegenüber werden diese Kosten nur verrechnet, wenn dies einzelvertraglich ausverhandelt wurde. Wir sind nur bei ausdrücklicher Vereinbarung verpflichtet, Verpackung zurückzunehmen.</li>
                            </ol>
                        </li>

                        <li>
                            <strong>Beigestellte Ware</strong>
                            <ol>
                                <li>Werden Geräte oder sonstige Materialien vom Kunden bereitgestellt, sind wir berechtigt, dem Kunden einen Zuschlag von 15 % des Werts der beigestellten Geräte bzw. des Materials zu berechnen.</li>
                                <li>Der Kunde verpflichtet sich, nur Ware beizustellen, die mit den Herstellervorgaben übereinstimmen.</li>
                                <li>Solche vom Kunden beigestellte Geräte und sonstige Materialien sind nicht Gegenstand von Gewährleistung.</li>
                            </ol>
                        </li>

                        <li>
                            <strong>Zahlung</strong>
                            <ol>
                                <li>Ein Drittel des Entgeltes wird bei Vertragsabschluss, ein Drittel bei Leistungsbeginn und der Rest nach Leistungsfertigstellung fällig.</li>
                                <li>Die Berechtigung zu einem Skontoabzug bedarf einer ausdrücklichen, gegenüber unternehmerischen Kunden schriftlichen Vereinbarung.</li>
                                <li>Vom Kunden vorgenommene Zahlungswidmungen auf Überweisungsbelegen sind für uns nicht verbindlich.</li>
                                <li>Bei Zahlungsverzug berechnen wir 9,2 % über dem Basiszinssatz gegenüber Unternehmern, 8 % gegenüber Verbrauchern.</li>
                                <li>Die Geltendmachung weiterer Verzugsschäden bleibt vorbehalten.</li>
                                <li>Bei Zahlungsverzug im Rahmen anderer Vertragsverhältnisse sind wir berechtigt, unsere Leistungen bis zur Erfüllung durch den Kunden einzustellen.</li>
                                <li>Forderungen aus bereits erbrachten Leistungen aus laufender Geschäftsbeziehung können fällig gestellt werden.</li>
                                <li>Aufrechnungsbefugnis des Kunden nur, soweit Gegenansprüche gerichtlich festgestellt oder anerkannt.</li>
                                <li>Abtretung von Forderungen ohne unsere Zustimmung nicht erlaubt.</li>
                                <li>Bei Direktverrechnungszusage nicht zahlender Versicherungen verpflichtet sich der Kunde zur Zahlung.</li>
                                <li>Überschreitung der Zahlungsfrist führt zu Verfall gewährter Vergütungen.</li>
                                <li>Mahnungskosten pro Mahnung € 10 bei verschuldetem Zahlungsverzug.</li>
                            </ol>
                        </li>

                        <li>
                            <strong>Zurückbehaltung des Kfz</strong>
                            <ol>
                                <li>Zurückbehaltungsrecht für alle Forderungen aus dem Auftrag, auch für Ersatz notwendiger Aufwendungen.</li>
                                <li>Forderungen des Kunden auf Ausfolgung an ihn oder Dritte können wir bis zur vollständigen Bezahlung entgegenhalten.</li>
                            </ol>
                        </li>

                        <li>
                            <strong>Bonitätsprüfung</strong>
                            <ol>
                                <li>Der Kunde erklärt Einverständnis zur Übermittlung von Daten an Gläubigerschutzverbände wie AKV, ÖVC, ISA, KSV.</li>
                            </ol>
                        </li>

                        <li>
                            <strong>Mitwirkungspflichten des Kunden</strong>
                            <ol>
                                <li>Leistungsausführung beginnt erst nach Schaffung aller baulichen, technischen und rechtlichen Voraussetzungen.</li>
                                <li>Bereitstellung notwendiger Angaben zu Hochvoltkomponenten, Hydraulikanlagen, Umbauplänen etc.</li>
                                <li>Kosten für Bewilligungen Dritter trägt der Kunde.</li>
                                <li>Kosten für Treibstoff/Energie für Probebetrieb trägt der Kunde.</li>
                                <li>Hinweis auf nicht betriebsrelevante Gegenstände im Fahrzeug.</li>
                                <li>Information über Garantievereinbarungen mit Dritten.</li>
                                <li>Hinweis auf Mitwirkungspflicht bei Vertragsabschluss.</li>
                                <li>Leistung nicht mangelhaft, wenn Mitwirkungspflicht nicht erfüllt wurde.</li>
                            </ol>
                        </li>

                        <li>
                            <strong>Leistungsausführung</strong>
                            <ol>
                                <li>Änderungs- und Erweiterungswünsche nur bei technischen Gründen.</li>
                                <li>Geringfügige Änderungen gelten als genehmigt.</li>
                                <li>Abänderungen nach Auftrag verlängern Liefer-/Leistungsfrist.</li>
                                <li>Kürzere Leistungsausführungen stellen Vertragsänderungen dar.</li>
                            </ol>
                        </li>

                        <li>
                            <strong>Leistungsfristen und Termine</strong>
                            <ol>
                                <li>Fristen verschieben sich bei höherer Gewalt, Streik, Verzögerung durch Zulieferer.</li>
                                <li>Liefer- und Fertigstellungstermine nur verbindlich, wenn schriftlich zugesagt.</li>
                                <li>Bei Verzug durch uns Recht auf Rücktritt nach Nachfristsetzung.</li>
                            </ol>
                        </li>

                        <li>
                            <strong>Beschränkung des Leistungsumfanges</strong>
                            <ol>
                                <li>Unerhebliche Beschädigungen bzw. Kratzer sind keine Mängel.</li>
                                <li>Lackunterschiede möglich.</li>
                                <li>Kunde erteilt Einwilligung zur Beschränkung.</li>
                            </ol>
                        </li>

                        <li>
                            <strong>Probefahrten</strong>
                            <ol>
                                <li>Kunde ermächtigt Probe- und Überstellungsfahrten.</li>
                            </ol>
                        </li>

                        <li>
                            <strong>Pannendienst / Behelfsmäßige Instandsetzung</strong>
                            <ol>
                                <li>Behelfsmäßige Instandsetzungen haben begrenzte Haltbarkeit.</li>
                                <li>Kunde veranlasst fachgerechte Instandsetzung.</li>
                                <li>Beschädigte Alufelgen sind auszutauschen.</li>
                            </ol>
                        </li>

                        <li>
                            <strong>Altteile</strong>
                            <ol>
                                <li>Ersetzte Altteile werden bis Übergabe aufbewahrt. Tauschaggregate ausgenommen.</li>
                            </ol>
                        </li>

                        <li>
                            <strong>Tauschaggregate</strong>
                            <ol>
                                <li>Tauschaggregate sind generalüberholt, schadhafte Aggregate müssen zurückgegeben werden.</li>
                            </ol>
                        </li>

                        <li>
                            <strong>Abstellung von Fahrzeugen</strong>
                            <ol>
                                <li>Abholfrist nicht eingehalten → Abstellgebühr.</li>
                                <li>Abholbereites Fahrzeug kann an Drittverwahrer übergeben werden.</li>
                            </ol>
                        </li>

                        <li>
                            <strong>Gefahrtragung</strong>
                            <ol>
                                <li>Verbraucher trägt Gefahr ab bedungener Übergabe.</li>
                                <li>Unternehmerische Kunden tragen Gefahr ab Bereitstellung zur Abholung.</li>
                                <li>Gefahrenübergang bei Versand an Verbraucher gemäß § 7B KSCHG.</li>
                            </ol>
                        </li>

                        <li>
                            <strong>Annahmeverzug</strong>
                            <ol>
                                <li>Fahrzeug bei Annahmeverzug verwahren, Lagergebühr berechnen.</li>
                                <li>Entgelt für erbrachte Leistungen wird fällig, Rücktritt nach Nachfrist möglich.</li>
                                <li>Schadenersatz pauschaliert 5 % des Auftragswerts.</li>
                                <li>Geltendmachung höheren Schadens nur unter bestimmten Bedingungen.</li>
                                <li>Außergerichtliche Verwertung / Entsorgung nach Aufforderung möglich.</li>
                            </ol>
                        </li>

                        <li>
                            <strong>Eigentumsvorbehalt</strong>
                            <ol>
                                <li>Gelieferte Ware bleibt bis zur vollständigen Bezahlung Eigentum von uns.</li>
                                <li>Herausgabe bei Zahlungsverzug möglich.</li>
                                <li>Kunde informiert uns vor Insolvenz oder Pfändung.</li>
                                <li>Kunde erlaubt Betreten des Lagerortes zur Geltendmachung des Eigentumsvorbehaltes.</li>
                                <li>Kunde trägt Kosten der Rechtsverfolgung.</li>
                                <li>Rücktritt nur bei ausdrücklicher Erklärung.</li>
                            </ol>
                        </li>

                        <li>
                            <strong>Gewährleistung</strong>
                            <ol>
                                <li>Gesetzliche Gewährleistungsbestimmungen gelten.</li>
                                <li>Fristen: 1 Jahr bei neuen, ½ Jahr bei Tauschaggregaten.</li>
                                <li>Übergabezeitpunkt gilt als Fertigstellung.</li>
                                <li>Zug-um-Zug-Übergabe, Übernahme gilt als erfolgt bei Fernbleiben.</li>
                                <li>Behebung von Mängeln kein Anerkenntnis.</li>
                                <li>Mindestens 2 Versuche zur Mängelbehebung.</li>
                                <li>Unberechtigte Mängel → Kostenerstattung durch Kunden.</li>
                                <li>Kunde muss Mangel beweisen.</li>
                                <li>Mängel innerhalb 5 Tagen anzeigen.</li>
                                <li>Bei Nutzung mangelhafter Teile, Schäden vermeiden.</li>
                                <li>Verspätete Mängelrüge → Ware gilt als genehmigt.</li>
                                <li>Wandlungsbegehren abwendbar durch Verbesserung/Preisminderung.</li>
                                <li>Kunde ermöglicht Mangelfeststellung.</li>
                                <li>Reparaturgegenstand bei uns überstellen.</li>
                                <li>Kosten für Rücktransport trägt der Kunde.</li>
                                <li>Gewährleistung ausgeschlossen, wenn beigestellte Teile mangelhaft sind.</li>
                            </ol>
                        </li>

                        <li>
                            <strong>Haftung</strong>
                            <ol>
                                <li>Haftung nur bei Vorsatz oder grober Fahrlässigkeit.</li>
                                <li>Haftungshöchstbetrag durch Versicherung.</li>
                                <li>Beschränkung gilt auch für Sachschäden.</li>
                                <li>Schadenersatz innerhalb 2 Jahre geltend machen.</li>
                                <li>Haftung für Mitarbeiter, Vertreter und Erfüllungsgehilfen eingeschränkt.</li>
                                <li>Haftungsausschluss bei unsachgemäßer Behandlung, Abnutzung, Unterlassung von Wartung.</li>
                                <li>Haftung auf Nachteile aus Versicherungsinanspruchnahme beschränkt.</li>
                            </ol>
                        </li>

                        <li>
                            <strong>Datenschutz / -verlust</strong>
                            <ol>
                                <li>Speicherung und Austausch individueller Kundendaten bei Reparaturarbeiten.</li>
                                <li>Individuelle Daten können verloren gehen.</li>
                                <li>Kunde nimmt dies zustimmend zur Kenntnis.</li>
                            </ol>
                        </li>

                        <li>
                            <strong>Salvatorische Klausel</strong>
                            <ol>
                                <li>Unwirksame Teile berühren die Gültigkeit der übrigen Teile nicht.</li>
                                <li>Ersatzregelung soll wirtschaftlich ähnliche Wirkung erzielen.</li>
                            </ol>
                        </li>

                        <li>
                            <strong>Allgemeines</strong>
                            <ol>
                                <li>Österreichisches Recht sowie ÖNORMEN V5050, V5051 und V5080 gelten.</li>
                                <li>UN-Kaufrecht ausgeschlossen.</li>
                                <li>Erfüllungsort: Zur Weide 14, 9581 Ledenitzen.</li>
                                <li>Alternative Streitbeilegung für Verbraucher möglich.</li>
                                <li>Gerichtsstand: für Unternehmer Sitz des Unternehmens, für Verbraucher örtlich zuständiges Gericht.</li>
                                <li>Corona-Pandemie als höhere Gewalt berücksichtigt.</li>
                            </ol>
                        </li>
                    </ol>
                </div>
            </div>
        </div>

    );
}